import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invocation
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const r = await api.post(
          "/auth/session",
          null,
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(r.data.user);
        // Clean hash and go home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile", { replace: true, state: { user: r.data.user } });
      } catch {
        navigate("/login?error=1", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <main className="min-h-[60vh] grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary mx-auto animate-spin" />
        <p className="text-muted-foreground mt-4">Signing you in…</p>
      </div>
    </main>
  );
}
